// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f921ac40ba7c8a4e2405","293":"86207b87d39eabc1037a","518":"e6cae13e6432659b9a46","779":"df4eb60145c5cf818094"}[chunkId] + ".js";
};